import React from 'react';
import { useVoteStore } from '../../stores/voteStore';
import { VoteTiers } from './VoteTiers';
import { PhoneInput } from './PhoneInput';
import { PaymentStatus } from './PaymentStatus';
import { X } from 'lucide-react';
import { useContestant } from '../../hooks/useContestant';
import { LoadingSpinner } from '../shared/LoadingSpinner';

export const VoteModal = () => {
  const { isOpen, contestantId, closeModal } = useVoteStore();
  const { contestant, isLoading } = useContestant(contestantId);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 overflow-y-auto">
      <div className="flex min-h-screen items-center justify-center p-4">
        <div className="fixed inset-0 bg-black/50 transition-opacity" />
        
        <div className="relative w-full max-w-md rounded-lg bg-white p-6 shadow-xl">
          <button
            onClick={closeModal}
            className="absolute right-4 top-4 text-gray-400 hover:text-gray-500"
          >
            <X className="h-6 w-6" />
          </button>

          {isLoading ? (
            <LoadingSpinner />
          ) : (
            <div className="space-y-6">
              <div className="text-center">
                <h3 className="text-xl font-semibold text-gray-900">
                  Voter pour {contestant?.name}
                </h3>
                <p className="mt-2 text-gray-600">
                  Choisissez le nombre de votes que vous souhaitez attribuer
                </p>
              </div>

              <VoteTiers />
              <PhoneInput />
              <PaymentStatus />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};